import { DOCUMENT } from '@angular/common'
import { inject, provideAppInitializer } from '@angular/core'

import { environment as env } from '@env'

export const freedompayConfigurationInitializer = provideAppInitializer(() => {
	const document = inject(DOCUMENT)
	const script = document.createElement('script')

	script.src = env.freedompayScript
	document.head.appendChild(script)
})
